/* eslint-disable no-redeclare */
import { z } from 'zod';

// TODO: Add validation for HealthcareUserId
export const HealthcareSessionId = z
  .string()
  .regex(/^[0-9]{14}\.[0-9a-f]{12}(\.nv)?$/, 'Invalid Healthcare session id');

export type HealthcareSessionId = z.infer<typeof HealthcareSessionId>;
